import {AssetCategory} from '../../const';

export type AssetCategorySelectionValue = AssetCategory | null;
